import { useState } from 'react';
import { api } from '../api.ts';

/**
 * Einen Auftrag über die Suche wählen - für das Postfach und für „Neue Mail".
 *
 * ÜBER DIE SUCHE, NICHT ÜBER EINE KENNUNG. Eine Auftragskennung ist eine
 * UUID; wer sie abtippen muss, tippt sie falsch, und dann hängt die Mail am
 * falschen Auftrag - genau der Fehler, den die automatische Zuordnung
 * vermeidet, mit der Hand wieder eingebaut.
 */
export function ZuordnenKnopf(
  { laeuft, tu, offenVon, ohneAufheben, titel }: {
    laeuft: boolean; tu: (auftragId: string | null, text?: string) => void;
    offenVon?: boolean; ohneAufheben?: boolean; titel?: string;
  }
) {
  const [auf, setAuf] = useState(!!offenVon);
  const [suche, setSuche] = useState('');
  const [treffer, setTreffer] = useState<any[]>([]);
  const [sucht, setSucht] = useState(false);

  async function suchen() {
    setSucht(true);
    try {
      const p = new URLSearchParams({ suche, proSeite: '20' });
      const r = await api.auftraege(p);
      setTreffer(r.zeilen ?? []);
    } catch { setTreffer([]); }
    finally { setSucht(false); }
  }

  if (!auf) {
    return (
      <button type="button" className="knopf" disabled={laeuft}
              onClick={() => setAuf(true)}>
        {titel ?? 'Einem Auftrag zuordnen'}
      </button>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <div className="reihe">
        <input type="search" autoComplete="off" value={suche} autoFocus
               placeholder="Adresse, Ort, KLS, SM-Nummer"
               onChange={(e) => setSuche(e.target.value)}
               onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); suchen(); } }} />
        <button type="button" className="knopf" onClick={suchen} disabled={sucht}>Suchen</button>
        <button type="button" className="knopf" onClick={() => setAuf(false)}>Abbrechen</button>
      </div>
      {treffer.length === 0 && !sucht && suche && (
        <p className="klein leise">Kein Auftrag passt dazu.</p>
      )}
      <ul className="klein" style={{ margin: '8px 0 0', paddingLeft: 18 }}>
        {treffer.map((t) => {
          const text = `${t.strasse} ${t.hausnummer}, ${t.plz} ${t.ort_text}${t.kls_id ? `, ${t.kls_id}` : ''}`;
          return (
            <li key={t.id} style={{ margin: '4px 0' }}>
              <button type="button" className="kartenweg"
                      onClick={() => { setAuf(false); tu(t.id, text); }}>
                {text} &rarr;
              </button>
            </li>
          );
        })}
      </ul>
      {!ohneAufheben && (
        <button type="button" className="knopf" style={{ marginTop: 8 }}
                onClick={() => { setAuf(false); tu(null); }}>
          Zuordnung aufheben
        </button>
      )}
    </div>
  );
}
